// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_backContainer__1ouYJ {
  margin-left: 0.5rem; }
  .styles_backContainer__1ouYJ span {
    margin: 0rem 0.5rem; }

.styles_forwardContainer__FEYPA {
  margin-right: 0.5rem;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center; }
  .styles_forwardContainer__FEYPA button {
    display: flex;
    flex-direction: row-reverse; }
  .styles_forwardContainer__FEYPA span {
    margin: 0rem 0.75rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Screen/ScreenSidePanel/ScreenNavigation/styles.module.scss"],"names":[],"mappings":"AACA;EACE,mBAAmB,EAAA;EADrB;IAGI,mBAAmB,EAAA;;AAGvB;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB,EAAA;EALrB;IAOI,aAAa;IACb,2BAA2B,EAAA;EAR/B;IAWI,oBAAoB,EAAA","sourcesContent":["\n.backContainer {\n  margin-left: 0.5rem;\n  & span {\n    margin: 0rem 0.5rem;\n  }\n}\n.forwardContainer {\n  margin-right: 0.5rem;\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  & button {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n  & span {\n    margin: 0rem 0.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backContainer": `styles_backContainer__1ouYJ`,
	"forwardContainer": `styles_forwardContainer__FEYPA`
};
export default ___CSS_LOADER_EXPORT___;
